<script setup lang="ts">
import ButtonRegular from './ButtonRegular.vue'

defineProps({
  size: {
    type: String as () => '50' | '44' | '32',
    default: '44',
  },
  disabled: {
    type: Boolean,
    default: false,
  },
})
</script>

<template>
  <ButtonRegular
    class="rounded-12 border-1 border-black-300 enabled:hover:border-black-100 enabled:active:border-black-100 enabled:active:bg-black-300 border-solid bg-white text-black enabled:hover:bg-white"
    :size="size"
    :disabled="disabled"
  >
    <slot />
  </ButtonRegular>
</template>
